import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import SignHashForm from "../components/SignHashForm";
import { WalletInfo, useWallet } from "../contexts/WalletContext";
import { parseSignHashUrl } from "../utils/helpers";
import { ethers } from "ethers";
import {
  useAccount,
  useDisconnect,
  useSignMessage,
  createConfig,
  http,
} from "wagmi";
// import { signMessage } from "@wagmi/core";
import { metaMask } from "@wagmi/connectors";
import { getAccount } from "@wagmi/core";

import "./SignHashPage.css";
import { baseSepolia } from "viem/chains";

function SignHashPage() {
  const [recoveryHash, setRecoveryHash] = useState(null);
  const location = useLocation();
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();

  // const { signer, network } = useWallet();
  const {
    signMessage,
    data: signature,
    isLoading,
    isError,
    error,
  } = useSignMessage({
    onSuccess(data) {
      console.log("Signature:", data);
      const recoveredAddress = ethers.verifyMessage(recoveryHash.hash, data);
      console.log("Recovered address:", recoveredAddress);
      if (recoveredAddress.toLowerCase() !== address.toLowerCase()) {
        console.error(
          "Recovered address does not match the connected address."
        );
      }
    },
  });

  useEffect(() => {
    const { axrWalletAddress, generatedHash } = parseSignHashUrl(
      location.search
    );
    if (axrWalletAddress && generatedHash) {
      setRecoveryHash({
        walletAddress: axrWalletAddress,
        hash: generatedHash,
      });
    }
  }, [location]);

  const handleSignHash = async (hash) => {
    try {
      if (!hash) {
        throw new Error("Hash is required");
      }

      console.log("Original hash:", hash);

      // Ensure the hash is in the correct format (0x-prefixed hex string)
      const formattedHash = hash.startsWith("0x") ? hash : `0x${hash}`;

      // Create the Ethereum Signed Message
      const message = ethers.concat([
        ethers.toUtf8Bytes("\x19Ethereum Signed Message:\n32"),
        ethers.getBytes(formattedHash),
      ]);

      // Hash the message
      const messageHash = ethers.keccak256(message);
      console.log("Message hash to be signed:", messageHash);

      await signMessage({
        message: { raw: hash },
      });
      console.log("Signature:", signature);
    } catch (error) {
      console.error("Error signing hash:", error);
      return null;
    }
  };

  return (
    <div className="sign-hash-page">
      {/* <Navbar activePage="sign-hash" /> */}
      {recoveryHash ? (
        <SignHashForm
          recoveryHash={recoveryHash}
          onSignHash={handleSignHash}
          isConnected={isConnected}
          isLoading={isLoading}
          signature={signature}
        />
      ) : (
        <p>No recovery hash found in URL. Please generate a hash first.</p>
      )}
    </div>
  );
}

export default SignHashPage;
